import './App.scss'
import '@aws-amplify/ui-react/styles.css'
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react'
import { AppBar, Box, Button, CssBaseline, styled, ThemeProvider, Toolbar, Typography } from '@mui/material'
import { Link, Route, Routes, useNavigate } from 'react-router-dom'
import AdminPage from './admin/AdminPage'
import AirportReportsPage from './reports/AirportReportsPage'
import AirportsPage from './airports/AirportsPage'
import theme from './init-mui-theme'
import { useTranslation } from 'react-i18next'
import Error403Page from './Error403Page'
import Error404Page from './Error404Page'
import Error500Page from './Error500Page'
import useAirports from './airports-hook'
import AirportsContext from './AirportsContext'
import AirportsMenu from './AirportsMenu'
import { useEffect, useState } from 'react'

const displayableEnv = process.env.REACT_APP_DISPLAYABLE_ENV

const App = () => {
  const { t } = useTranslation()
  const { airports, airportsLoadingError } = useAirports()
  const { user, signOut } = useAuthenticator((context) => [context.user])
  const [loggedOut, setLoggedOut] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    console.log('user logged in: ', user)
    if (!user && loggedOut) {
      navigate('/')
    }
  }, [user, loggedOut, navigate])

  const signOutAndRedirect = () => {
    setLoggedOut(true)
    signOut()
  }

  const MainContainer = styled('main')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flex: '1 1 auto',
    height: 'calc(100vh - 64px)',
  })

  const AppContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  })

  const components = {
    Header() {
      return (
        <Box textAlign="center">
          <img alt="be-safe" src={`${process.env.PUBLIC_URL}/be-safe-logo.png`} className="login-logo" />
        </Box>
      )
    },
  }

  return (
    <Authenticator hideSignUp components={components}>
      <ThemeProvider theme={theme}>
        <AirportsContext.Provider value={airports}>
          <AppContainer>
            <CssBaseline />
            <AppBar>
              <Toolbar>
                {airports && <AirportsMenu airports={airports} />}
                <Link to="/" style={{ display: 'flex' }}>
                  <img alt="be-safe" src={`${process.env.PUBLIC_URL}/be-safe-logo.png`} className="logo" />
                </Link>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  {t('app.title')}
                  {displayableEnv && ` [${displayableEnv}]`}
                </Typography>
                <Button key="logout" sx={{ color: '#fff' }} onClick={signOutAndRedirect}>
                  {t('app.logoutButton')}
                </Button>
              </Toolbar>
            </AppBar>
            <Toolbar />
            <MainContainer>
              {airportsLoadingError ? (
                <Error500Page />
              ) : (
                <Routes>
                  <Route path="/" element={<AirportsPage />}>
                    <Route path=":airportIcao" element={<AirportReportsPage />}></Route>
                  </Route>
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/403" element={<Error403Page />} />
                  <Route path="/404" element={<Error404Page />} />
                  <Route path="/500" element={<Error500Page />} />
                  <Route path="/*" element={<Error404Page />} />
                </Routes>
              )}
            </MainContainer>
          </AppContainer>
        </AirportsContext.Provider>
      </ThemeProvider>
    </Authenticator>
  )
}

export default App
